import { render, staticRenderFns } from "./sql-mode.vue?vue&type=template&id=2456e4e6&scoped=true&"
import script from "./sql-mode.vue?vue&type=script&lang=ts&"
export * from "./sql-mode.vue?vue&type=script&lang=ts&"
import style0 from "./sql-mode.vue?vue&type=style&index=0&id=2456e4e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456e4e6",
  null
  
)

export default component.exports